import { useEffect, useState } from "react";

// Punto centrale dell'isola — sufficiente per un dato di vento "d'insieme"
const ELBA_CENTER = { lat: 42.809, lng: 10.313 };

const DIRS = [
  "Tramontana",
  "Grecale",
  "Levante",
  "Scirocco",
  "Mezzogiorno",
  "Libeccio",
  "Ponente",
  "Maestrale",
];

export function windName(deg) {
  const normalized = ((deg % 360) + 360) % 360;
  return DIRS[Math.round(normalized / 45) % 8];
}

export function useLiveWind() {
  const [wind, setWind] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${ELBA_CENTER.lat}&longitude=${ELBA_CENTER.lng}&current=wind_speed_10m,wind_direction_10m&timezone=Europe%2FRome`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`vento ${res.status}`);
        const json = await res.json();
        if (cancelled || !json.current) return;
        const deg = json.current.wind_direction_10m;
        setWind({
          deg,
          speed: Math.round(json.current.wind_speed_10m),
          name: windName(deg),
          time: json.current.time,
        });
        setError(false);
      } catch {
        if (!cancelled) setError(true);
      }
    }

    load();
    const id = setInterval(load, 10 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return { wind, error };
}
